// extracted by mini-css-extract-plugin
module.exports = {"experience":"Experience_experience__1xzyR","excard":"Experience_excard__3uc3J","excontent":"Experience_excontent__25fXb","hatdate":"Experience_hatdate__2T3XA"};